<div [class.sidebar-active]="!applicationStateService.isSidebarHidden && !applicationStateService.isZoomed"
     [class.zoomed]="applicationStateService.isZoomed"
     class="bookviewer-footer">
    <div class="bookviewer-footer-chapters">
        <div class="bookviewer-footer-chapter-left">
            <app-chapter-switcher [previous]="true"></app-chapter-switcher>
        </div>
        <div class="bookviewer-footer-page-switcher">
            <app-page-switcher></app-page-switcher>
            <app-mobile-tools-bar></app-mobile-tools-bar>
        </div>
        <div class="bookviewer-footer-chapter-right">
            <app-chapter-switcher [next]="true"></app-chapter-switcher>
        </div>
    </div>
</div>
